import { render, staticRenderFns } from "./EmergencyTab.vue?vue&type=template&id=4a656908&"
import script from "./EmergencyTab.vue?vue&type=script&lang=ts&"
export * from "./EmergencyTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a656908')) {
      api.createRecord('4a656908', component.options)
    } else {
      api.reload('4a656908', component.options)
    }
    module.hot.accept("./EmergencyTab.vue?vue&type=template&id=4a656908&", function () {
      api.rerender('4a656908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/EmergencyTab.vue"
export default component.exports